import React, { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { CompetitionsPrizePlaceWidget } from 'widgets/competitions-b2b/prize-place';
import { useParams } from 'react-router';

export const PrizePlacePage = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(setHeaderTitle('Призовое место'));
    dispatch(setActionBtnTitle('Редактировать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, [dispatch]);

  return <CompetitionsPrizePlaceWidget awardPlaceId={parseInt(id!)} />;
};
